// src/components/admin/AdminNavbar.js
import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  Avatar,
  useScrollTrigger,
  Slide,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BusinessIcon from "@mui/icons-material/Business";
import logo from "../../Assets/logo.png";

// Styled components for professional look
const StyledAppBar = styled(AppBar)(({ theme }) => ({
  background: "linear-gradient(135deg, #1800ad 0%, #f57226 100%)",
  boxShadow: "0 8px 32px rgba(24, 0, 173, 0.12)",
  backdropFilter: "blur(10px)",
  borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
}));

const StyledToolbar = styled(Toolbar)({
  minHeight: "70px",
  padding: "0 24px",
});

const LogoBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  flexGrow: 1,
});

const NavButton = styled(Button)(({ theme }) => ({
  color: "white",
  marginLeft: "16px",
  padding: "8px 20px",
  borderRadius: "25px",
  textTransform: "none",
  fontWeight: "500",
  transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    transform: "translateY(-2px)",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
  },
}));

function HideOnScroll(props) {
  const { children } = props;
  const trigger = useScrollTrigger();

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

const GuestNavbar = () => {
  return (
    <HideOnScroll>
      <StyledAppBar position="fixed" elevation={0}>
        <StyledToolbar>
          <LogoBox>
            <Avatar
              src={logo}
              sx={{
                bgcolor: "rgba(255, 255, 255, 0.12)",
                mr: 2,
                width: 45,
                height: 45,
                border: "1px solid rgba(255,255,255,0.18)",
              }}
            >
              {!logo && <BusinessIcon sx={{ color: "white" }} />}
            </Avatar>
            <Typography
              variant="h5"
              noWrap
              component="div"
              sx={{
                fontWeight: "bold",
                background:
                  "linear-gradient(45deg, #ffffff 30%, #f0f0f0 90%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                textShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              تطبيق ادارة المطاعم ريستو كاش
            </Typography>
          </LogoBox>

          <Box sx={{ display: "flex", alignItems: "center" }}>
            <NavButton
              variant="outlined"
              sx={{
                borderColor: "rgba(255, 255, 255, 0.3)",
                "&:hover": {
                  borderColor: "white",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                },
              }}
            >
              <AccountCircleIcon sx={{ mr: 1 }} />
              حسابي
            </NavButton>
          </Box>
        </StyledToolbar>
      </StyledAppBar>
    </HideOnScroll>
  );
};

export default GuestNavbar;
